

import {  BoxesIcon, Building, LayoutDashboard, LogOutIcon, MapIcon, MapPinIcon, Menu, PuzzleIcon, ShieldCheckIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { routes } from "routes";
import { ReplaceWords } from "utils/ReplaceWords";
import { createContext, useContext, useState } from "react";
import { Button } from "components/Button/Button";

import { useDispatch, useSelector } from "react-redux";
import { useLangContext } from "context/Lang";
import { Sidebar } from "components/Sidebar/Sidebar";
import { Logo } from "components/Logo/Logo";
import { RootStateType } from "storeRedux/store";
import { UserImage } from "components/UserImage/UserImage";
import { UserTypes } from "assets/Roles";
import { AsyncProcess } from "services/AsyncProcess";
import { setToast } from "storeRedux/slices/toast";



// }






const DashboardContext = createContext<DashboardContextProps>({});

export const DashboardProvider = ({ ...props }) => {

    const auth = useSelector((state: RootStateType) => state.auth);

    const [loading,setLoading] = useState<boolean>(false);
    const [counts,setCounts] = useState<DashboardCountsType>({})
    const dispatch = useDispatch();
    const { user } = auth;



    const navigate = useNavigate();
    const { gW, LanguagesDrop } = useLangContext();
    const [isOpenSide, setISOpenSide] = useState(false);






    const getDashboard = () => {
        if(loading===false){

            AsyncProcess({
                type: "get",
                url: `${routes.api.dashboard}`,
                setError: () => {
                    dispatch(setToast({ detail: gW("happen-error"), severity: "error" }));
                    setLoading(false);

                },
                effectProcess: [(res) => {
                    if (res?.success === false) {
                        dispatch(setToast({ detail: gW(res?.message||"happen-error"), severity: "error" }));
                    }else {
                        setCounts(res?.data);
                    }
                    setLoading(false);
                }]
            });
        }
    }





    const values: DashboardContextProps = {
        getDashboard,
        counts,
        loading

    }




    const sideItems: ListItemType[] = [

        {
            id: 0,
            label: gW("dashboard"),
            icon: LayoutDashboard,
            url: routes.dashboard
        },
        ...([UserTypes.ACADEMIC,UserTypes.MANAGER] as any).includes(user?.userType) ?[
            {
                id: 1,
                label: gW("buildings"),
                icon: Building,
                url: ReplaceWords(routes.dashboardRroute, { route: routes.dashboardRroutes.buildings })
            },

          
        ]:[],


        ...([UserTypes.MANAGER] as any).includes(user?.userType) ?[

            {
                id: 2,
                label: gW("maps"),
                icon: MapIcon,
                url: ReplaceWords(routes.dashboardRroute, { route: routes.dashboardRroutes.maps })
            },
        ]:[],


        ...([UserTypes.ACADEMIC] as any).includes(user?.userType) ?[

            {
                id: 2,
                label: gW("assigned-maps"),
                icon: MapIcon,
                url: ReplaceWords(routes.dashboardRroute, { route: routes.dashboardRroutes.assignedMaps })
            },
        ]:[],

        ...([UserTypes.STUDENT] as any).includes(user?.userType) ?[
            {
                id: 3,
                label: gW("assigned-buildings"), 
                icon: ShieldCheckIcon,
                url: ReplaceWords(routes.dashboardRroute, { route: routes.dashboardRroutes.assignedBuildings })
            },
        ]:[],
        {
            id: 4,
            label: gW("avatar-editor"),
            icon: PuzzleIcon,
            url: ReplaceWords(routes.dashboardRroute, { route: routes.dashboardRroutes.avatarEditor })
            
        },
        {
            id: 4,
            label: gW("active-maps"),
            icon: MapPinIcon,
            url: ReplaceWords(routes.dashboardRroute, { route: routes.dashboardRroutes.activeMaps })
            
        },
        // {
        //     id:0,
        //     label:gW("lessons"),
        //     icon:Book,
        //     url: ReplaceWords(routes.dashboardRroute,{route:"lessons"})
        // },

        {
            id: 99999,
            label: gW("logout"),
            icon: LogOutIcon,
            url: routes.logout
        }

    ]





    return (<DashboardContext.Provider value={values}>
        <div className=" absolute  z-10 end-8   top-4  ">
            <LanguagesDrop />

        </div>

        <div className="h-full w-full md:flex overflow-auto " >

            {/* <div className=" h-full hidden md:block  w-64  " >

            </div> */}
            <div className="  block      " >


                <div className=" h-12 border-b flex md:hidden    items-center   " >
                    <Button
                        className=" bg-blue-50 border-blue-600 text-blue-600  border-2 ml-2 p-2    "
                        onClick={() => setISOpenSide(priv => !priv)}
                    >
                        <Menu />
                    </Button>
                </div>

                <Sidebar
                    className=" border-r   bg-white   "
                    isSidebarOpen={isOpenSide}
                    setIsSidebarOpen={() => setISOpenSide(priv => !priv)}
                    icon={
                        user?.image ? <div onClick={() => { navigate("/") }} className="flex text-sm gap-2 cursor-pointer select-none  font-mono items-center   " >
                            <UserImage />
                            <div>
                                <p>{user.name}</p>
                                <p>{user.surname}</p>
                            </div>
                        </div> :
                            <Logo size={0.4} onClick={() => { navigate("/") }} />
                    }
                    position="fixed"
                    sideItems={sideItems}
                />

                <Sidebar
                    showLabel={false}
                    className=" border-e-2 hidden md:block    "
                    icon={
                        <>

                            {user?.image ? <div onClick={() => { setISOpenSide(priv => !priv) }} className="flex text-sm gap-2 cursor-pointer select-none  font-mono items-center   " >
                                <UserImage />
                                <div className=" flex gap-2 " >
                                    <p>{user?.name}</p>
                                    <p>{user?.surname}</p>
                                </div>
                            </div> :
                                <Logo size={0.4} onClick={() => { setISOpenSide(priv => !priv) }} />}
                        </>
                    }
                    position="relative"
                    sideItems={sideItems}
                />
            </div>
            <div className="  w-full  px-2  sm:p-4  md:p-8 lg:p-12 xl:p-16  overflow-y-auto   " >
                {props.children}
            </div>

        </div>
        {/* {block&&<Loading/>} */}
    </DashboardContext.Provider>)
}



export const useDashboardContext = () => useContext<DashboardContextProps>(DashboardContext);
